import React from "react";
import {
  WSButton,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { openIntercom } from "../../../../../shared/utils/intercom";
import { openInNewTab } from "../../../../../shared/utils/openInNewTab";

export const MeridioNeedToMakeChanges: React.FC = () => (
  <WSInfoBox title="Need to make changes?" icon="help-circle">
    <WSList gap="L">
      <WSText.ParagraphSm color="gray700">
        Once enrolled, please contact Meridio to make any changes. Information
        updated in Wingspan is not synced to Meridio.
      </WSText.ParagraphSm>

      <WSList gap="XS">
        <WSText.ParagraphSm color="gray700" inline>
          Call Meridio:{" "}
          <WSButton.Link onClick={() => openInNewTab("tel:+18556970007")}>
            (855) 697-0007
          </WSButton.Link>
        </WSText.ParagraphSm>
        <WSText.ParagraphSm color="gray700" inline>
          Email:{" "}
          <WSButton.Link
            onClick={() => openInNewTab("mailto:hello@getmeridio.com")}
          >
            hello@getmeridio.com
          </WSButton.Link>
        </WSText.ParagraphSm>
      </WSList>

      <WSText.ParagraphSm color="gray700" inline>
        Problems with billing? Contact{" "}
        <WSButton.Link onClick={openIntercom}>Wingspan support</WSButton.Link>
      </WSText.ParagraphSm>
    </WSList>
  </WSInfoBox>
);
